import React from "react";
import { usePriceUpdates } from "../hooks/usePriceUpdates";

const FeeInfo = () => {
  const { price: livePrice } = usePriceUpdates();
  return (
    <div className="mt-6 text-sm space-y-2 border-2 border-[--border-color] p-4 bg-[--bg-secondary]">
      <p className="font-bold">
        • All rates include network fees and exchange spreads
      </p>
      <p className="font-bold">
        • Calculations are based on the current Bitcoin price ($
        {livePrice.toLocaleString()} CAD)
      </p>
      <p className="font-bold">
        • Interac e-Transfer is instant for verified accounts
      </p>
      <p className="font-bold">• Wire transfers may take 1-3 business days</p>
    </div>
  );
};

export default FeeInfo;
